// TODO: This file will be deleted once the data is moved to the DB
import Brand from 'helpers/brand'

const HELP_VIDEOS = {
  archiving_devices: {
    asairUrl: 'https://ircohvac.wistia.com/medias/sa8p2my30x',
    traneUrl: 'https://ircohvac.wistia.com/medias/1acisxalzq',
    tooltip: 'Watch a video describing how to Archive Devices',
    gaLabel: 'Dealer Diagnostics: Archiving Devices',
    name: 'Archiving Devices',
    description: 'How to archive a device.'
  },
  awair: {
    asairUrl: 'https://ircohvac.wistia.com/medias/ugp7egqoka',
    traneUrl: 'https://ircohvac.wistia.com/medias/0xkv3ktz9a',
    tooltip: 'Watch a video describing the Awair Runtime History Graph in Diagnostics',
    gaLabel: 'Diagnostics Awair® Runtime History',
    name: 'Awair® Runtime History',
    description: 'Awair® Runtime history instructional walkthrough.'
  },
  drc_xxl: {
    asairUrl: 'https://ircohvac.wistia.com/medias/mkxku3h04c',
    traneUrl: 'https://ircohvac.wistia.com/medias/3u8v3upd7q',
    tooltip: 'Watch a video describing how to request remote access (DRC)',
    gaLabel: 'Dealer Diagnostics: Dealer Remote Configuration',
    name: 'Dealer Remote Configuration',
    description: 'How to request a remote session from the web. Link systems are not applicable. See DRC for Link.'
  },
  drc_link: {
    asairUrl: 'https://ircohvac.wistia.com/medias/o3sej6rd6o',
    traneUrl: 'https://ircohvac.wistia.com/medias/dahcyirrja',
    tooltip: 'Watch a video describing how to request remote access (DRC) from the mobile app',
    gaLabel: 'Diagnostics Mobile App: DRC',
    name: 'Dealer Remote Configuration (DRC) for Link',
    description: 'How to request a remote session from the Diagnostics Mobile app.'
  },
  notifications: {
    asairUrl: 'https://ircohvac.wistia.com/medias/2t4yx70s8j',
    traneUrl: 'https://ircohvac.wistia.com/medias/wwcmlh8kqz',
    tooltip: 'Watch a video describing how to add Notification Recipients to start receiving Alert Emails',
    gaLabel: 'Diagnostics Training Video: Notification Recipients',
    name: 'Notification Recipients',
    description: 'How to add notification recipients and make selections to receive alert emails.'
  },
  rth: {
    asairUrl: 'https://ircohvac.wistia.com/medias/m47pwvo56d',
    traneUrl: 'https://ircohvac.wistia.com/medias/qi7u2zqxl6',
    tooltip: 'Watch a video describing the Runtime History Graph in Diagnostics',
    gaLabel: 'Dealer Diagnostics: Runtime History Legend',
    name: 'Runtime History',
    description: 'Runtime history instructional walkthrough including how to add and remove data in the graph.'
  },
  sdas: {
    asairUrl: 'https://ircohvac.wistia.com/medias/dz77v7v41c',
    traneUrl: 'https://ircohvac.wistia.com/medias/0uzanv5s5z',
    tooltip: 'Watch a video describing Smart Diagnostics Alerts',
    gaLabel: 'Dealer Diagnostics: Smart Diagnostics Alerts',
    name: 'Smart Diagnostics Alerts',
    description: 'What are Smart Diagnostics Alerts and how to differentiate them from Equipment Alerts.'
  }
}

export const helpVideos = () => {
  let videos

  if (Brand.isASAirHome()) {
    videos = Object.keys(HELP_VIDEOS).map((key) => {
      const video = HELP_VIDEOS[key]
      return {
        ...video,
        key,
        url: video.asairUrl,
        gaLabel: 'AS ' + video.gaLabel
      }
    })

    return videos
  } else {
    videos = Object.keys(HELP_VIDEOS).map((key) => {
      const video = HELP_VIDEOS[key]
      return {
        ...video,
        key,
        url: video.traneUrl,
        gaLabel: 'Trane ' + video.gaLabel
      }
    })

    return videos
  }
}

export const helpVideo = (key) => {
  const videos = helpVideos()

  return videos.find((video) => video.key === key)
}
